import React, { useState, useEffect, Fragment } from 'react'
import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select as MuiSelect,
    TextField,
    Typography,
    CircularProgress,
    Autocomplete,
    Divider,
    Alert,
    AlertTitle
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { getRequest, getStandardDate, postRequest } from '../../globalhelper/helper';
import NewDynamicTable from './NewDynamicTable';
import { CSVLink } from 'react-csv';
import { connect, useDispatch } from 'react-redux'
import { hideLoader, showLoader } from '../../redux/Common/commonActions';

const convertToINRs = (number) => {
    const roundedNumber = Math.floor(Number(number))
    const num = roundedNumber.toLocaleString("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 0 })
    return num
}

const DeferredRevenueAndAmortization = (props) => {

    const [tableData, setTableData] = useState([])
    const [companyName, setCompanyName] = useState([])
    const [companyDetails, setCompanyDetails] = useState([])
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [selectedDate, setSelectedDate] = useState(moment())
    const [formData, setFormData] = useState({
        company: "",
        fromDate: "",
        toDate: ""
    })
    const dispatch = useDispatch()

    useEffect(() => {
        getRequest(`api/edureka/getUserDetailsOfLastLogin?user=${props.state.login.userData.USR_Email}&screen=${localStorage.getItem("pageName")}`).then(response => {
            if (response?.res?.data?.length) {
                const data = response.res.data[0]
                setFormData({
                    company: data.companyName
                })
                if (data.month && data.year) {
                    setSelectedDate(moment(`${data.month} ${data.year}`, 'MMMM YYYY'))
                }
            }
        }).catch(err => {
            console.error(err)
        })
    }, [])

    useEffect(() => {
        getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
            const responseData = response.res.data
            const orgname = responseData.map(item => item.orgname)
            setCompanyDetails(responseData)
            setCompanyName(orgname)
        })
    }, [])

    useEffect(() => {
        if (selectedDate && selectedDate.isValid()) {
            const startDate = selectedDate.clone().startOf('month').toDate()
            const endDate = selectedDate.clone().endOf('month').toDate()

            setFormData(prev => {
                return { ...prev, fromDate: getStandardDate(startDate), toDate: getStandardDate(endDate) }
            })
        }
    }, [selectedDate])

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData((prev) => {
            return { ...prev, [name]: value }
        })
    }

    const handleDateChange = (newValue) => {
        setSelectedDate(newValue)
    }

    const handleReset = () => {
        setFormData({
            fromDate: '', toDate: '', company: ''
        })
        setSelectedDate(moment())
        setTableData([])

        setShowError(false)
    }

    const handleSubmit = () => {
        const { fromDate, toDate, company } = formData

        if (fromDate && toDate && company) {
            dispatch(showLoader())
            setShowError(false)
            setTableData([])

            const id = companyDetails.filter(item => item.orgname === company)

            const companyid = id.map(item => item.orgid)

            const postData = {
                companyName: company,
                companyID: companyid[0],
                month: selectedDate.format('MMMM'),
                year: selectedDate.format('YYYY'),
                screen: localStorage.getItem("pageName"),
                mailID: props.state.login.userData.USR_Email
            }

            // Submit logic

            Promise.all([
                getRequest(`api/edureka/getDeferredRevenueAndAmortization?fromDate=${fromDate}&toDate=${toDate}&company=${companyid[0]}`),
                getRequest(`api/edureka/setUserDetailsOfDeferredRevenueAndAmortization?companyName=${postData.companyName}&companyID=${postData.companyID}&month=${postData.month}&year=${postData.year}&screen=${postData.screen}&mailID=${postData.mailID}`)
            ]).then(([response, value]) => {
                const responseData = JSON.parse(response.res.data)
                if (responseData.length) {
                    setTableData(responseData)

                } else {

                    setShowError(true)
                    setErrorMessage("No data found, please try some other combination")
                }
            }).catch(err => {
                console.log(err)

                setShowError(true)
                setErrorMessage("Oops something went wrong!!")
            }).finally(() => {
                dispatch(hideLoader())
            })

            // getRequest(`api/edureka/getDeferredRevenueAndAmortization?fromDate=${fromDate}&toDate=${toDate}&company=${companyid[0]}`).then(response => {
            //     const responseData = JSON.parse(response.res.data)
            //     if(responseData.length){
            //         setTableData(responseData)
            //         
            //     } else {
            //         
            //         setShowError(true)
            //         setErrorMessage("No data found, please try some other combination")
            //     }   
            // }).catch(err => {
            //     
            //     setShowError(true)
            //     setErrorMessage("Oops something went wrong!!")
            // })
        } else {
            setShowError(true)
            setErrorMessage("Please select all the required fields")
        }
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Container maxWidth="xl" sx={{ py: 4 }}>

                <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12} md={5}>
                            <Autocomplete
                                options={companyName.sort()}
                                value={formData.company || null}
                                onChange={(event, newValue) => {
                                    setFormData(prev => ({ ...prev, company: newValue || "" }))
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Company" variant="outlined" size="small" fullWidth />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <DatePicker
                                views={['year', 'month']}
                                label="Month and Year"
                                minDate={moment('2023-01-01')}
                                maxDate={moment('2030-12-31')}
                                value={selectedDate}
                                onChange={handleDateChange}
                                renderInput={(params) => <TextField {...params} size="small" fullWidth variant="outlined" />}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleSubmit}
                                    sx={{ minWidth: 100, fontWeight: 'bold', borderRadius: 2 }}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={handleReset}
                                    sx={{ minWidth: 100, fontWeight: 'bold', borderRadius: 2 }}
                                >
                                    Reset
                                </Button>
                                {tableData.length > 0 && (
                                    <CSVLink
                                        data={tableData}
                                        filename="Deferred_Revenue_Amortization_Report.csv"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <Button
                                            variant="contained"
                                            color="warning"
                                            sx={{ minWidth: 100, fontWeight: 'bold', borderRadius: 2 }}
                                        >
                                            Download
                                        </Button>
                                    </CSVLink>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>

                <Box sx={{ mt: 4 }}>

                    <>
                        {tableData.length > 0 ? (
                            <NewDynamicTable data={tableData} />
                        ) : (
                            showError && (
                                <Alert severity='warning' sx={{ borderRadius: 2 }}>
                                    <AlertTitle>No Data Found</AlertTitle>
                                    {errorMessage || "There is no data to display at the moment."}
                                </Alert>
                            )
                        )}
                    </>

                </Box>
            </Container>
        </LocalizationProvider>
    )
}

function mapStateToProps(state) {
    return {
        state
    }
}

export default connect(mapStateToProps)
    (DeferredRevenueAndAmortization)